export default __webpack_public_path__ + "static/media/price.bdc08bcd.svg";